// メッセージ内容に関わらず無視するエラー型
const IGNORED_ERROR_TYPES = ['ChunkLoadError']

// メッセージパターンによる無視対象。`type`を指定した場合はexceptionのtypeも
// 一致している必要がある（AND条件）。未指定の場合はメッセージのみで判定する。
const IGNORED_ERROR_MESSAGE_PATTERNS: { type?: string; pattern: RegExp }[] = [
  { pattern: /^Unexpected token '<'$/ },
  {
    type: 'FirebaseError',
    pattern: /^Firebase: Error \(auth\/popup-blocked\)\.$/,
  },
  {
    type: 'FirebaseError',
    pattern: /^Firebase: Error \(auth\/network-request-failed\)\.$/,
  },
  // Firebase Installations/Remote Configの既知のSDKノイズ。
  // Firebase公式が一時的なもので無視して問題ないと回答しており
  // （https://github.com/firebase/firebase-js-sdk/issues/9408,
  // https://github.com/firebase/firebase-js-sdk/issues/7988）、
  // アプリ側での解決手段も存在しない
  {
    type: 'FirebaseError',
    pattern:
      /\((installations\/not-registered|remoteconfig\/storage-get|remoteconfig\/storage-set|remoteconfig\/fetch-client-network)\)\.?$/,
  },
  // Firebase Installationsのネットワークfetch失敗
  { type: 'TypeError', pattern: /firebaseinstallations\.googleapis\.com/ },
]

export type SentryException = {
  type?: string
  value?: string
}

/**
 * SentryのbeforeSendで、送信対象から除外すべき既知のノイズエラーかどうかを判定する。
 *
 * @param exception - Sentryイベントの`exception.values`内の1要素
 * @returns `IGNORED_ERROR_TYPES`の型に一致する、または`IGNORED_ERROR_MESSAGE_PATTERNS`の
 *          いずれかのパターン（`type`指定時はexceptionのtypeも一致）に合致する場合true
 */
export function isIgnoredException(exception: SentryException): boolean {
  return (
    (!!exception.type && IGNORED_ERROR_TYPES.includes(exception.type)) ||
    IGNORED_ERROR_MESSAGE_PATTERNS.some(
      ({ type, pattern }) =>
        (type === undefined || exception.type === type) &&
        pattern.test(exception.value ?? '')
    )
  )
}
